import React from "react";
import { useNavigate } from "react-router-dom";
import Icon_adult from "../../assets/images/icons/icon_adult.svg";

export default function AuthenticationError() {
  const navigate = useNavigate();

  const handleSubmit = () => {
    navigate("/home", { replace: true });
  };
  return (
    <div id="join">
      <div className="container">
        <div className="row gx-2 gx-sm-2 gx-md-3">
          <div className="col-12 col-md-6 col-md-4 mx-auto">
            <div>
              <div
                className="mb-4"
                style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 120 }}
              >
                <img src={Icon_adult} alt="adult" style={{ display: "block", width: 80 }} />
                <h2 className="mt-3">룰루플레이 회원 성인 인증 실패</h2>
                <p className="text-center">인증에 실패했습니다. 다시 시도해주세요.</p>
              </div>
              <button className="button" onClick={handleSubmit}>
                메인으로
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
